const hooks = {
    //
};

export default hooks;